
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M20.53 0v35.86M13.68 35a15.53 15.53 0 0022.38-14 15.41 15.41 0 00-2-7.66M28.72 7.87a15.54 15.54 0 00-22.5 19.25M5.03 21.07h31"}}),_c('path',{attrs:{"d":"M24.28 13.06c-1.19-.09-2.39-.13-3.61-.13A49.31 49.31 0 006.52 15M20.25 29.22h.37a49.22 49.22 0 0014.13-2.06","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M14.32 7a49.2 49.2 0 00-2 14v.8M26.74 35.14a49.2 49.2 0 002-14c0-1.36-.05-2.7-.16-4","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12.32 37.36a17.54 17.54 0 00-3.47-4.93A17.7 17.7 0 003.94 29a17.7 17.7 0 004.93-3.5 17.49 17.49 0 003.45-4.92 17.8 17.8 0 003.47 4.93A17.56 17.56 0 0020.71 29a17.56 17.56 0 00-8.39 8.39zM29.22 18.31a12.2 12.2 0 00-2.38-3.38 12.06 12.06 0 00-3.37-2.37 12.2 12.2 0 003.38-2.38 12.06 12.06 0 002.37-3.37 12.36 12.36 0 002.38 3.38 12.06 12.06 0 003.4 2.37 12.2 12.2 0 00-3.38 2.38 12.06 12.06 0 00-2.4 3.37z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    